module.exports = __webpack_public_path__ + "img/retraction.bedd4f4d.svg";